import { getBreadCrumbList, setTagNavListInLocalstorage, getMenuByRouter, getTagNavListFromLocalstorage, getHomeRoute, routeHasExist } from '@/libs/util'
import routers from '@/router/routers'
export default {
  state: {
    breadCrumbList: [],
    tagNavList: [],
    homeRoute: getHomeRoute(routers),
    local: ''
  },
  getters: {
    menuList: (state, getters, rootState) => getMenuByRouter(routers, rootState.user.access)
  },
  mutations: {
    setBreadCrumb (state, routeMetched,oldMetched) {
      state.breadCrumbList = getBreadCrumbList(routeMetched,oldMetched, state.homeRoute)
    },
    setTagNavList (state, list) {
      if (list) {
        state.tagNavList = [...list]
        setTagNavListInLocalstorage([...list])
      } else state.tagNavList = getTagNavListFromLocalstorage()
    },
    addTag (state, { route, type = 'unshift' }) {
      if( typeof route.name !== 'undefined' && route.name ) {
        if (!routeHasExist(state.tagNavList, route)) {
          if (type === 'push') state.tagNavList.push(route)
          else {
            if (route.name === 'home') state.tagNavList.unshift(route)
            else state.tagNavList.splice(1, 0, route)
          }
          setTagNavListInLocalstorage([...state.tagNavList])
        }else {
          // 解决编辑ID不变问题
          if( route.hasOwnProperty('params') && route.params.length > 0 ){
            const tagIndex = state.tagNavList.findIndex(v => v.name === route.name)
            if (tagIndex && state.tagNavList[tagIndex]) {
               state.tagNavList[tagIndex].params = route.params
               setTagNavListInLocalstorage([...state.tagNavList])
            }
          }
        }
      }
      // if (!routeHasExist(state.tagNavList, route)) {
      //   if (type === 'push') state.tagNavList.push(route)
      //   else {
      //     if (route.name === 'home') state.tagNavList.unshift(route)
      //     else state.tagNavList.splice(1, 0, route)
      //   }
      //   setTagNavListInLocalstorage([...state.tagNavList])
      // }
    },
    setLocal (state, lang) {
      state.local = lang
    }
  }
}




// WEBPACK FOOTER //
// ./src/store/module/app.js